module.exports = __webpack_public_path__ + "img/calendar.12716421.svg";